import { ca } from '@cian/analytics';

import { EAdvantageType } from '../../types/newobject/newbuildingAdvantages';

export function trackAdvantagesItemClick(label: EAdvantageType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'click_features_jk',
    label,
    useLastProducts: true,
  });
}

export function trackNewbuildingLinkClick(customUrl: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'to_JKCard_about_block',
    label: customUrl,
    useLastProducts: true,
  });
}
